import { useMutation } from 'react-query';
import { getAllLicensesAsync } from '../../index';

export const useGetAllLicensesAsync = () => useMutation(getAllLicensesAsync);
